// We use esbuild

// Because of ES6 hositing, imports get executed before `window` commands. By putting everything
// that needs to become global into ./globals.js, we can expose jQuery, Backbone, etc. to all
// JS code
import "./globals"
import './jquery-ui'
import 'jquery-ujs'
import 'moment'
import './underscore'
import 'keymaster'
import './jquery.comiseo.daterangepicker'
import './jquery.tablesorter.min'

// Import application-specific modules
import './placeholders'
import './pairing'
import './questionnaires'
import './contact'

// Import Backbone modules
import './backbone/app'
import './backbone/models/group'
import './backbone/models/photo'
import './backbone/models/report'
import './backbone/models/user'
import './backbone/collections/reports'
import './backbone/views/control'
import './backbone/views/group'
import './backbone/views/groups'
import './backbone/views/photo'
import './backbone/views/report'
import './backbone/views/zoom'
import './backbone/views/zoom_photo'
import "@hotwired/turbo-rails"
import "./controllers"
